import React, { useContext } from 'react';
import Select from '../../../components/engine/SelectEngine';
import HelpIcon from '../../HelpIcon';
import { getAllFields } from '../../form-builder/getAllFields';
import EmailDialog, {
  EMAIL_DIALOG_TYPES
} from '../../../components/engine/EmailDialogEngine';
import Context from '../../GeneralContext';
import getJWT from '../../../utils/getJWT';
import useTranslations from '../../../hooks/useTranslations';
import styled from 'styled-components/macro';

const HelpTooltipContent = (
  <div>
    <p>
      Some users may receive a reminder about multiple submissions that meet
      your reminder conditions. The {'{list submissions}'} placeholder below
      will list all the submissions in a generic way. For example:
    </p>
    <p>
      <b>
        Submission 1 <br />
        Submission 2
      </b>
    </p>
    <p>
      You can customise the list by using this drop-down to select a field from
      your form and make the submission more recognisable to your users. For
      example:
    </p>
    <p>
      <b>
        Matter ID - 12345 <br />
        Matter ID - 45678
      </b>
    </p>
  </div>
);

const HelpText = styled.div`
  font-weight: 500;
  font-style: italic;
  font-size: 14px;
  margin-top: 0.8em;
  color: white;
  background: #4c84ff;
  border-radius: 5px;
  padding: 0.8em;
`;

const getFieldName = (fieldId, allFields) => {
  const field = allFields.find(f => f.internalId === fieldId);
  if (!field) {
    return 'error';
  }
  return field.title || `Untitled ${field.uiType} field`;
};

const ReminderEmailTemplateEditorView = props => {
  const { form } = useContext(Context);
  const t = useTranslations();

  const getAdditionalPlaceHolders = () => {
    const additionalPlaceHolders = getAllFields(form).map(field => ({
      value: field.internalId,
      text: field.title || `Untitled ${field.uiType} field`,
      'data-testid': `placeholder-field-${field.internalId}`
    }));
    additionalPlaceHolders.push({
      value: 'referenceId',
      text: 'referenceId',
      'data-testid': `placeholder-field-child.referenceId`
    });
    return additionalPlaceHolders;
  };

  return (
    <EmailDialog
      maxWidth="lg"
      open={props.isOpen}
      handleConfirm={props.onEmailDialogConfirmed}
      handleClose={props.handleClose}
      type={EMAIL_DIALOG_TYPES.TEMPLATE}
      allowNewTemplateCreation
      templateId={props.templateId}
      setTemplateId={props.setTemplateId}
      additionalPlaceHolders={getAdditionalPlaceHolders()}
      additionalPlaceHoldersProps={{ placeholder: 'Insert field placeholder' }}
      editTemplateProps={{
        additionalSettings: (
          <HelpText>
            <b>Note: </b>
            {t('form-builder.reminders.emailTemplate.description')}
          </HelpText>
        )
      }}
      // editTemplateProps={{
      //   additionalSettings: (
      //     <>
      //       <br />
      //       <Select
      //         searchable
      //         //   variant="contained"
      //         value={props.templateListItemValue}
      //         options={getAllFields(form).map(field => ({
      //           value: field.internalId,
      //           text: field.title || `Untitled ${field.uiType} field`,
      //           'data-testid': `placeholder-field-${field.internalId}`
      //         }))}
      //         onChange={props.setTemplateListItemValue}
      //         label={
      //           <>
      //             Use a form field for listing submissions
      //             <HelpIcon title={HelpTooltipContent} />
      //           </>
      //         }
      //         placeholder="Insert field placeholder"
      //       />
      //     </>
      //   )
      // }}
      customBodyParsing={props.injectListPlaceolder}
      previewEmailProps={{
        customParsingFunc: props.parseList4Preview,
        customMapping: {
          '${formTitle}': form.title,
          ...(props.templateListItemValue && props.templateListItemValue.length
            ? {
                '${list of submissions}': `</div><div><ul><li><a href="#"> ${getFieldName(
                  props.templateListItemValue,
                  getAllFields(form)
                )} - {1} </a></li><li><a href="#"> ${getFieldName(
                  props.templateListItemValue,
                  getAllFields(form)
                )} - {2} </a></li></ul></div><div>`
              }
            : {}),
          '${sender.firstName}': getJWT().userProfile.firstName
        }
      }}
    />
  );
};

export default ReminderEmailTemplateEditorView;
